export default __webpack_public_path__ + "static/0131-d13a129c55c326240a247b5e3142aae8.png";